import { useState, useEffect } from "react";
import logo from "../../assets/images/Inca-Logo-WHite 1.svg";
import { menus } from "../../constants/menus";
import sliderCloseImage from "../../assets/images/slider-close-icon.svg";
import dashboardIcon from "../../assets/images/dashboard-icon.svg";
import dashboardIconActive from "../../assets/images/dashboard-icon-active.svg";
import contantListIconActive from "../../assets/images/contact-list-icon-active.svg";
import contantListIcon from "../../assets/images/contact-list-icon.svg";
import $ from "jquery";
import messageIcon from "../../assets/images/messages-icon.svg";
import messageIconActive from "../../assets/images/messages-icon-active.svg";

import voiceMailIcon from "../../assets/images/voice-mails-icon.svg";
import voiceMailIconActive from "../../assets/images/voice-mails-icon-active.svg";

import customMessageIcon from "../../assets/images/custom-message-icon.svg";
import customMessageIconActive from "../../assets/images/custom-message-icon-active.svg";

import settingsIconActive from "../../assets/images/settings-icon-active.svg";
import settingsIcon from "../../assets/images/settings-icon.svg";
import SupportModal from "./SupportModal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Box, Image } from "@chakra-ui/react";
import { useSelector, dispatch, useDispatch } from "react-redux";
import {
  signoutUser,
  fetchMessages,
  fetchUnReadCountData,
  fetchVoicemails,
  logoutAsync,
  changeFontSize,
} from "../../redux/action";
import { HamburgerIcon } from "@chakra-ui/icons";

function LeftNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);
  const userselectedFont = useSelector((state) => state.settings.fontsize);

  const [isVisible, setIsVisible] = useState(false);

  const messages = useSelector((state) => state.messages);
  const voicemails = useSelector((state) => state.voicemails);

  const [isCustomMessage, setIsCustomMessage] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [active, setActive] = useState("/");

  const handleMessageModal = () => {
    setIsVisible((old) => !old);
  };

  const getMessages = () => {
    dispatch(fetchUnReadCountData());
    dispatch(fetchMessages());
  };

  const getVoicemails = () => {
    dispatch(fetchVoicemails());
  };

  const hideLeft = () => {
    $(".left-navigation").animate(
      {
        width: 0,
      },
      function () {
        $(".main-section").css("width", "100%");
        $("#leftMenuBtn").addClass("d-none");
        $("#headerMenuBtn").removeClass("d-none");
      }
    );

    /*document.getElementsByClassName('left-navigation')[0].style.width='0px';
    document.getElementsByClassName('left-navigation')[0].style.padding='0px';
   // document.getElementsByClassName('left-navigation')[0].animate({width:'0px',padding:'0px'},"slow")
    document.getElementById("headerMenuBtn").classList.remove("d-none")
    document.getElementById("leftMenuBtn").classList.add("d-none")*/
  };

  const handleActive = () => {
    if (location.pathname === "/") setActive("/");
    else if (location.pathname === "/contacts") setActive("/contacts");
    else if (location.pathname === "/messages") setActive("/messages");
    else if (location.pathname === "/voicemail") setActive("/voicemail");
    else if (location.pathname === "/missed-calls") {
      setActive("/missed-calls");
      setIsCustomMessage(true);
    } else if (location.pathname === "/wait-time") {
      setActive("/wait-time");
      setIsCustomMessage(true);
    } else if (location.pathname === "/templates") {
      setActive("/templates");
      setIsCustomMessage(true);
    } else if (location.pathname === "/reminders") {
      setActive("/reminders");
      setIsCustomMessage(true);
    } else if (location.pathname === "/profile") {
      setActive("/profile");
      setIsSetting(true);
    } else if (location.pathname === "/payments") {
      setActive("/payments");
      setIsSetting(true);
    } else if (location.pathname === "/preferences") {
      setActive("/preferences");
      setIsSetting(true);
    } else if (location.pathname === "/blocked-numbers") {
      setActive("/blocked-numbers");
      setIsSetting(true);
    } else if (location.pathname === "/employees") {
      setActive("/employees");
      setIsSetting(true);
    } else if (location.pathname === "/voicemail-destination") {
      setActive("/voicemail-destination");
      setIsSetting(true);
    } else if (location.pathname === "/audit-logs") {
      setActive("/audit-logs");
      setIsSetting(true);
    } else if (location.pathname === "/change-password") {
      setActive("/change-password");
      setIsSetting(true);
    }
  };

  const handleLogout = () => {
    dispatch(signoutUser());
    navigate("/login");
  };

  useEffect(() => {
    getMessages();
    getVoicemails();
    handleActive();
  }, []);

  useEffect(() => {
    handleActive();
  }, [location.pathname]);

  const handleMobileLeftBtn = () => {
    $(".left-navigation").css("display", "none");
  };

  return (
    <>
      <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12 left-navigation">
        <div className="d-flex flex-column justify-content-between ">
          <div className="">
            <div
              style={{ padding: "30px 20px" }}
              className="d-flex align-items-center  justify-content-between">
              <Image
                w={
                  userselectedFont === "small"
                    ? "75px"
                    : userselectedFont === "medium"
                    ? "90px"
                    : userselectedFont === "large"
                    ? "100px"
                    : "100px"
                }
                src={logo}
                className="img-fluid"
              />
              <Box
                mb="5px"
                cursor="pointer"
                fontSize={
                  userselectedFont === "small"
                    ? "18px"
                    : userselectedFont === "medium"
                    ? "20px"
                    : userselectedFont === "large"
                    ? "24px"
                    : "24px"
                }
                id="leftMenuBtn"
                className=" desktop-display">
                <HamburgerIcon color="white" onClick={hideLeft} />
              </Box>
              <button
                onClick={handleMobileLeftBtn}
                id="mobileLeftMenuBtn"
                className="slider-close-btn me-2 mobile-display">
                <img alt=" " src={sliderCloseImage} className="img-fluid" />
              </button>
            </div>
            {/*<div className="mt-5">
            <div className="d-flex align-items-center">
              <Link to={"/"}  onClick={()=>{setActive("/");setIsCustomMessage(false);setIsSetting(false)}}>
                <img alt=" " src={active==="/"?dashboardIconActive:dashboardIcon} />
                <span className={`nav-text ms-3 ${active==="/" && 'active'}`}>Dashboard</span>
              </Link>
            </div>
          </div>
          <div className="mt-4">
            <div className="d-flex align-items-center">
              <Link to={"/contacts"} onClick={()=>{setActive("/contacts");setIsCustomMessage(false);setIsSetting(false)}}>
                <img alt=" " src={active==="/contacts"? contantListIconActive:contantListIcon} />
                <span className={`nav-text ms-3 ${active==="/contacts" && 'active'}`}>Contacts List</span>
              </Link>
            </div>
          </div>
          <div className="mt-4">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <Link to={"/messages"} onClick={()=>{setActive("/messages");setIsCustomMessage(false);setIsSetting(false)}}>
                  <img alt=" " src={active==="/messages"?messageIconActive:messageIcon} />
                  <span className={`nav-text ms-3 ${active==="/messages" && 'active'} `}>Messages</span>
                </Link>
              </div>
              <div>
               {notifications && notifications.messages.length>0 &&<span className="messages-count">{notifications.messages.length}</span>}
              </div>
            </div>
  </div>*/}

            {menus.map((item, index) => (
              <Box
                _hover={{ color: "white" }}
                color={item.active.includes(active) ? "white" : "#8b8be2"}
                px="20px"
                py="10px"
                key={index}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                  className="">
                  <div>
                    <Link
                      style={{
                        display: "flex",
                        alignItems: "center",

                        color: "inherit",
                      }}
                      to={item.to}
                      onClick={() => {
                        setActive(item.to);

                        if (item.to === "/missed-calls") {
                          setIsCustomMessage(!isCustomMessage);
                          setIsSetting(false);
                        } else if (item.to === "/profile") {
                          setIsSetting(!isSetting);
                          setIsCustomMessage(false);
                        } else {
                          setIsSetting(false);
                          setIsCustomMessage(false);
                        }
                      }}>
                      <Image
                        boxSize={
                          userselectedFont === "small"
                            ? "25px"
                            : userselectedFont === "medium"
                            ? "30px"
                            : userselectedFont === "large"
                            ? "40px"
                            : "40px"
                        }
                        alt=" "
                        src={
                          item.active.includes(active)
                            ? item.activeIcon
                            : item.icon
                        }
                      />
                      <Box
                        style={{
                          fontSize:
                            userselectedFont === "small"
                              ? "12px"
                              : userselectedFont === "medium"
                              ? "14px"
                              : userselectedFont === "large"
                              ? "18px"
                              : "18px",
                        }}
                        fontWeight="600"
                        className={`ms-3 ${
                          item.active.includes(active) && "active"
                        } `}>
                        {item.title}
                      </Box>
                    </Link>
                  </div>

                  {item.to === "/voicemail" && (
                    <div>
                      {notifications && notifications.voicemails.length > 0 && (
                        <span className="messages-count ">
                          {notifications.voicemails.length}
                        </span>
                      )}
                    </div>
                  )}
                  {item.to === "/messages" && (
                    <div>
                      {notifications && notifications.messages.length > 0 && (
                        <span className="messages-count ">
                          {notifications.messages.length}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                {item.active.includes(active) && isCustomMessage && (
                  <div className="mt-2">
                    <div className="ps-5 d-flex gap-2 flex-column">
                      {item.subCategories &&
                        item.subCategories.map((item2, index) => (
                          <Box
                            _hover={{ color: "white" }}
                            style={{
                              fontSize:
                                userselectedFont === "small"
                                  ? "12px"
                                  : userselectedFont === "medium"
                                  ? "14px"
                                  : userselectedFont === "large"
                                  ? "18px"
                                  : "18px",
                            }}
                            color={
                              item2.active.includes(active)
                                ? "white"
                                : "#8b8be2"
                            }>
                            <Link
                              style={{
                                color: "inherit",
                              }}
                              key={index}
                              to={item2.to}
                              onClick={() => setActive(item2.to)}>
                              <span
                              // className={`sub-nav-text mt-3 ${
                              //   item2.active.includes(active) && "active"
                              // }`}
                              >
                                <i className="fa-solid fa-chevron-right me-2"></i>
                                {item2.title}
                              </span>
                            </Link>
                          </Box>
                        ))}
                    </div>
                  </div>
                )}

                {item.active.includes(active) && isSetting && (
                  <Box>
                    <div className="ps-5  d-flex flex-column mt-2 gap-2 ">
                      {item.subCategories &&
                        item.subCategories.map((item2, index) => (
                          <Box
                            _hover={{ color: "white" }}
                            style={{
                              fontSize:
                                userselectedFont === "small"
                                  ? "12px"
                                  : userselectedFont === "medium"
                                  ? "14px"
                                  : userselectedFont === "large"
                                  ? "18px"
                                  : "18px",
                            }}
                            color={
                              item2.active.includes(active)
                                ? "white"
                                : "#8b8be2"
                            }>
                            <Link
                              style={{
                                color: "inherit",
                              }}
                              key={index}
                              to={item2.to}
                              onClick={() => setActive(item2.to)}>
                              <span
                              // className={`sub-nav-text mt-3 ${
                              //   item2.active.includes(active) && "active"
                              // }`}
                              >
                                <i className="fa-solid fa-chevron-right me-2"></i>
                                {item2.title}
                              </span>
                            </Link>
                          </Box>
                        ))}
                    </div>
                  </Box>
                )}
              </Box>
            ))}

            {/*<div className="mt-4">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <Link to={"/voicemail"} onClick={()=>{setActive("/voicemail");setIsCustomMessage(false);setIsSetting(false)}}>
                  <img alt=" " src={active==="/voicemail"?voiceMailIconActive:voiceMailIcon} />
                  <span className={`nav-text ms-3 ${active==="/voicemail" && 'active'} `}>Voicemail </span>
                </Link>
              </div>
              <div>
                {notifications && notifications.voicemails.length>0 && <span className="messages-count ">{notifications.voicemails.length}</span>}
              </div>
            </div>
          </div>
  
          <div className="mt-4">
            <div className="d-flex align-items-center"  style={{cursor:'pointer'}}>
                <Link to={"/missed-calls"} onClick={()=>{setIsCustomMessage(!isCustomMessage);setActive('/missed-calls');setIsSetting(false)}}>
              <img alt=" " src={(active==="/missed-calls" || active==="/wait-time" ||  active==="/templates" ||  active==="/reminders")?customMessageIconActive:customMessageIcon} />
              <span className={`nav-text ms-3 ${(isCustomMessage ||(active==="/missed-calls" || active==="/wait-time" ||  active==="/templates" ||  active==="/reminders")) &&'active'}`}>Custom Messages</span>
               </Link>
            </div>
              </div>*/}

            {/*
         {
          isCustomMessage?<div className="mt-2">
            <div className="ps-5 d-flex flex-column">
              <Link to={"/missed-calls"} onClick={()=>setActive("/missed-calls")}>
                <span className={`sub-nav-text mt-3 ${active==="/missed-calls" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Missed Calls
                </span>
              </Link>
              <Link to={"/wait-time"} onClick={()=>setActive("/wait-time")}>
                <span className={`sub-nav-text mt-3 ${active==="/wait-time" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Wait Time
                </span>
              </Link>
              <Link to={"/templates"} onClick={()=>setActive("/templates")}>
                <span className={`sub-nav-text mt-3 ${active==="/templates" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right  me-2"></i>
                  Templates
                </span>
              </Link>
              <Link to={"/reminders"} onClick={()=>setActive("/reminders")}>
                <span className={`sub-nav-text mt-3 ${active==="/reminders" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Reminders
                </span>
              </Link>
            </div>
          </div>:''}
          <div className="mt-4">
            <div className="d-flex align-items-center">
              <Link to={"/profile"} onClick={()=>{setIsSetting(!isSetting);setActive("/profile");setIsCustomMessage(false);}}>
              <img alt=" " src={(active==="/profile" || active==="/payments" ||  active==="/preferences" || active==="/blocked-numbers" || active==="/employees" || active==="/voicemail-destination" || active==="/audit-logs")?settingsIconActive:settingsIcon} />
              <span className={`nav-text ms-3 ${(isSetting || active==="/profile") && 'active'}`}>Settings</span>
              </Link>
            </div>
         </div>


          
        {isSetting?<div className="mt-2">
            <div className="ps-5 d-flex flex-column">
              <Link to={"/profile"} onClick={()=>setActive("/profile")}>
                <span className={`sub-nav-text mt-3 ${active==="/profile" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Profile
                </span>
              </Link>
              <Link to={"/payments"} onClick={()=>setActive("/payments")}>
                <span className={`sub-nav-text mt-3 ${active==="/payments" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Payments
                </span>
              </Link>
              
              <Link to={"/preferences"} onClick={()=>setActive("/preferences")}>
                <span className={`sub-nav-text mt-3 ${active==="/preferences" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Preferences
                </span>
              </Link>
              <Link to={"/blocked-numbers"} onClick={()=>setActive("/blocked-numbers")}>
                <span className={`sub-nav-text mt-3 ${active==="/blocked-numbers" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Blocked Numbers
                </span>
              </Link>
              <Link to={"/employees"} onClick={()=>setActive("/employees")}>
                <span className={`sub-nav-text mt-3 ${active==="/employees" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Employees
                </span>
              </Link>
              <Link to={"/voicemail-destination"} onClick={()=>setActive("/voicemail-destination")}>
                <span className={`sub-nav-text mt-3 ${active==="/voicemail-destination" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Voicemail Destination
                </span>
              </Link>
              <Link to={"/audit-logs"} onClick={()=>setActive("/audit-logs")}>
                <span className={`sub-nav-text mt-3 ${active==="/audit-logs" && 'active'}`}>
                  <i className="fa-solid fa-chevron-right me-2"></i>
                  Audit Logs
                </span>
              </Link>
            </div>
         </div>:''}*/}
          </div>

          <Box
            display="flex"
            flexDir="column"
            gap={
              userselectedFont === "small"
                ? "14px"
                : userselectedFont === "medium"
                ? "18px"
                : userselectedFont === "large"
                ? "25px"
                : "25px"
            }
            mt={
              userselectedFont === "small"
                ? "8px"
                : userselectedFont === "medium"
                ? "12px"
                : userselectedFont === "large"
                ? "15px"
                : "15px"
            }>
            <Box
              _hover={{ color: "white" }}
              w="100%"
              display="flex"
              alignItems="center"
              gap="15px"
              fontSize={
                userselectedFont === "small"
                  ? "12px"
                  : userselectedFont === "medium"
                  ? "14px"
                  : userselectedFont === "large"
                  ? "18px"
                  : "10px"
              }
              px="20px"
              py="10px"
              cursor="pointer"
              className="support-btn"
              onClick={handleMessageModal}>
              <Box
                position="relative"
                padding={
                  userselectedFont === "small"
                    ? "12px"
                    : userselectedFont === "medium"
                    ? "14px"
                    : userselectedFont === "large"
                    ? "18px"
                    : "18px"
                }
                rounded="full"
                border="1px solid #8b8be2">
                <Box
                  position="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50%,-50%)">
                  <i className="fa-solid fa-headset "></i>
                </Box>
              </Box>
              Support
            </Box>
            <Box
              _hover={{ color: "white" }}
              w="100%"
              cursor="pointer"
              display="flex"
              alignItems="center"
              gap="15px"
              fontSize={
                userselectedFont === "small"
                  ? "12px"
                  : userselectedFont === "medium"
                  ? "14px"
                  : userselectedFont === "large"
                  ? "18px"
                  : "10px"
              }
              px="20px"
              py="15px"
              className="support-btn"
              onClick={handleLogout}>
              <Box
                position="relative"
                padding={
                  userselectedFont === "small"
                    ? "12px"
                    : userselectedFont === "medium"
                    ? "14px"
                    : userselectedFont === "large"
                    ? "18px"
                    : "18px"
                }
                rounded="full"
                border="1px solid #8b8be2">
                <Box
                  position="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50%,-50%)">
                  <i className="fa-solid fa-power-off "></i>
                </Box>
              </Box>
              Sign Out
            </Box>
          </Box>
        </div>
      </div>
      <SupportModal isVisible={isVisible} toggle={handleMessageModal} />
    </>
  );
}

export default LeftNavigation;
